export const workSetupOptions = [
  { id: 1, name: "On-site" },
  { id: 2, name: "Hybrid" },
  { id: 3, name: "Remote" },
];
